import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Tab, Tabs } from '@mui/material';
import AppLayout from '../../layout/app.layout';
import ListAppContentLabels from '../../components/app-content/list-app-content-labels.component';
import ListRokuPackages from '../../components/content/list-channel-packager';
import ListLGPackages from '../../components/content/list-channel-lg-packager';

const a11yProps = (index) => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
});

const ChannelPackager = () => {
  const id = 0;
  const [activeTab, setActiveTab] = useState(0);
  const [tabValue, setTabValue] = useState('roku');

  useEffect(() => {
    if (tabValue === 'roku') {
      setActiveTab(0);
    } else if (tabValue === 'lg') {
      setActiveTab(1);
    } else if (tabValue === 'fireTV') {
      setActiveTab(3);
    }
  }, [tabValue]);

  return (
    <AppLayout pageTitle="Manage Channels / Channel Packager">
      <Box>
        <Box>
          <Tabs
            value={tabValue}
            aria-label="tabs"
            indicatorColor="primary"
            onChange={(_, v) => {
              setTabValue(v);
            }}
          >
            <Tab value="roku" label="Roku" {...a11yProps(0)} />
            <Tab value="lg" label="LG" {...a11yProps(1)} />
            <Tab value="fireTV" label="FireTV" {...a11yProps(2)} disabled />
          </Tabs>
        </Box>
        <Box>
          {tabValue === 'roku' && (
            <TabPanel value={activeTab} index={0}>
              <ListRokuPackages value={activeTab} />
            </TabPanel>
          )}
          {tabValue === 'lg' && (
            <TabPanel value={activeTab} index={1}>
              <ListLGPackages value={activeTab} />
            </TabPanel>
          )}
          {tabValue === 'FireTV' && (
            <TabPanel value={activeTab} index={2}>
              <ListAppContentLabels channelId={id} />
            </TabPanel>
          )}
        </Box>
      </Box>
    </AppLayout>
  );
};

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
};

export default ChannelPackager;
